export default __webpack_public_path__ + "static/media/marking--discrete--symbol--bicycle.b160ff92.png";